import { faInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, Popover } from "@mui/material";
import { useState } from "react";

const valueWithOptions = (value, options) => {
  if (options) {
    return options[value.toString()] ? options[value.toString()] : value;
  }
  return value;
};

const TooltipButton = ({ ranges, options }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const { red, yellow, green } = ranges;

  return (
    <>
      <div style={{ flexGrow: 0 }}>
        <IconButton
          onClick={(event) => {
            setAnchorEl(event.currentTarget);
          }}
        >
          <FontAwesomeIcon icon={faInfo} style={{ fontSize: 10 }} />
        </IconButton>
      </div>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <div style={{ padding: "5px 0px" }}>
          <div style={{ display: "flex", height: 20 }}>
            <div
              style={{
                width: 5,
                height: "100%",
                background: red.background,
              }}
            ></div>
            <div>{`${red.min}- ${valueWithOptions(red.max, options)}`}</div>
          </div>
          <div style={{ display: "flex", height: 20 }}>
            <div
              style={{
                width: 5,
                height: "100%",
                background: yellow.background,
              }}
            ></div>
            <div>{`${yellow.min}- ${valueWithOptions(
              yellow.max,
              options
            )}`}</div>
          </div>
          <div style={{ display: "flex", height: 20 }}>
            <div
              style={{
                width: 5,
                height: "100%",
                background: green.background,
              }}
            ></div>
            <div>{`${green.min}- ${valueWithOptions(green.max, options)}`}</div>
          </div>
        </div>
      </Popover>
    </>
  );
};

export default TooltipButton;
